module.exports = __webpack_public_path__ + "img/ic_phone_rose.0eea7695.svg";